import React, { useEffect, useState } from 'react';
import { User } from '../contexts/UserContext';
import { HlsAudioPlayer } from '../utils/HlsAudioPlayer';
import waitForAudioStream from '../utils/ServerSideEventConsumer';

import SegmentChooser from './segments/SegmentChooser';
import { isUserSettingsValid } from './UserProfile';
import AppHeader from './AppHeader2';
import NewUser from './NewUser';

const SignedInUser: React.FC<{ user: User }> = ({ user }) => {
  const [newUserHlsPlayer] = useState<HlsAudioPlayer>(new HlsAudioPlayer());

  useEffect(() => {
    waitForAudioStream.initialize();
  }, []);

  return (
    <>
      <AppHeader newUserHlsPlayer={newUserHlsPlayer} />
      {isUserSettingsValid(user.settings) ? <SegmentChooser /> : <NewUser hlsAudioPlayer={newUserHlsPlayer} />}
    </>
  );
};

export default SignedInUser;